<template>
  <div class="preview m-auto">
    <transition name="alert">
      <AddCartDialog v-if="this.$store.state.isShowAddCartDialog" />
    </transition>

    <div class="d-flex">
      <div class="preview-area border border-1 border-dark" :style="getCanvasSize">
        <MainCanvas />
      </div>
      <div class="control-area d-flex flex-column justify-content-center" :style="getControlAreaHeight">
        <div class="fw-bold">
          <p>{{ getTitleText }}</p>
        </div>
        <div class="w-100 h-100 d-flex flex-column justify-content-end">
          <div class="row justify-content-between m-0 py-2">
            <div class="col-auto row p-0 m-0" @click="prevPage" style="cursor: pointer">
              <div class="col-auto p-0 pagination-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                  <path
                    d="M19.8155 9.2625L18.0365 7.5L10.4661 15L18.0365 22.5L19.8155 20.7375L14.0368 15L19.8155 9.2625Z"
                    fill="#8C9BC6"
                  />
                </svg>
              </div>
              <div class="col-auto px-1 my-auto pagination-text-select">前へ</div>
            </div>
            <div class="col-auto row p-0 m-0" @click="nextPage" style="cursor: pointer">
              <div class="col-auto px-1 my-auto pagination-text-select">次へ</div>
              <div class="col-auto p-0 pagination-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                  <path
                    d="M12.9634 7.5L11.1843 9.2625L16.9631 15L11.1843 20.7375L12.9634 22.5L20.5338 15L12.9634 7.5Z"
                    fill="#8C9BC6"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div class="row m-0 mx-2 flex">
            <div class="col p-0 m-auto pagination-text" v-for="(n, index) in this.getLoopNumList" :key="index">
              <span v-bind:class="{ 'pagination-text-select': currentPageNum == n }" @click="clickPage(n)">{{
                n
              }}</span>
            </div>
          </div>

          <div class="row m-2 mx-0">
            <div class="col row">
              <select v-model="jumpPageNum" class="w-100 text-input" style="width: 70px">
                <option v-for="n in quantity" v-bind:key="n">
                  {{ n }}
                </option>
              </select>
            </div>

            <div class="col-8 m-auto px-1" style="font-size: 15px">{{ editedNum }}/{{ quantity }} 編集済み</div>
          </div>

          <IsShowCutline />
          <PreviewMode :showModeSwitch="false" />

          <button class="preview-btn" @click="clickListPreview">一覧プレビュー</button>
        </div>
      </div>
    </div>
    <Precautions>
      <p class="m-0">・カットラインとデザインが交わっている箇所はプリントが剥がれやすくなります。</p>
      <p class="m-0">・プレビューによるデザインとカットラインを元に制作致します。</p>
      <p class="m-0">
        ・アタッチメントのつけ忘れ、5mm以下の小さなパーツは再現性の低下や破損に繋がります。また保証対象外となりますのでご注意ください。
      </p>
    </Precautions>
  </div>
</template>

<script>
import MainCanvas from "@/components/home/MainCanvas.vue";
import { CenterViewState, RightViewState, PreviewColorList, GetCanvasSize, ProductId } from "@/js/Const.js";
import { CreateFrameCutlineImage, ReplacePngColor } from "@/js/CommonFunc.js";
import AddCartDialog from "@/components/acyrpro/modal/dialog/AddCartDialog.vue";
import IsShowCutline from "@/components/acyrpro/preview/IsShowCutline.vue";
import PreviewMode from "@/components/acyrpro/preview/PreviewMode.vue";
import Precautions from "@/components/acyrpro/preview/Precautions.vue";

export default {
  name: "CenterViewEdit_Ap",
  components: {
    MainCanvas,
    AddCartDialog,
    IsShowCutline,
    PreviewMode,
    Precautions,
  },
  props: {},
  data: function () {
    return {
      cutlineMode: 0,

      jumpPageNum: 1,

      // ページネーション用
      currentPageNum: 1, // 現在のページ番号
    };
  },
  watch: {
    // カットラインカラー変更時
    "$store.state.designPreview.selectCutlineColor": async function () {
      // 色を取得
      const Color = PreviewColorList[this.$store.state.designPreview.selectCutlineColor];

      // 塗カットライン生成
      this.$store.commit("designPreview/set", {
        key: "originalCutlineImageURL",
        value: await ReplacePngColor(this.$store.state.designPreview.cutlineImagePngURL, Color),
      });

      // 線状のカットライン生成
      const blob = await CreateFrameCutlineImage(this.$store.state.designPreview.cutlineImagePngURL);
      const fileUrl = await ReplacePngColor(URL.createObjectURL(blob), Color);
      this.$store.commit("designPreview/set", { key: "cutlineContourImageURL", value: fileUrl });
    },
    "$store.state.currentSelectPlateNo": function () {
      if (this.$store.state.currentCanvasData) {
        for (const item of this.$store.state.currentCanvasData.itemList.slice()) {
          item.updateImage(this.$store.state.currentSelectPlateNo);
        }
      }
    },
    jumpPageNum: function () {
      if (!isNaN(this.jumpPageNum)) {
        let num = Number(this.jumpPageNum);
        if (0 < num && num <= this.getMaxPageNum) {
          this.currentPageNum = num;
          this.$store.commit("setCurrentSelectPlateNo", this.currentPageNum - 1);
        }
      }
    },
  },
  computed: {
    quantity() {
      return this.$store.state.currentProduct.quantity;
    },
    editedNum() {
      if (this.$store.state.currentCanvasData) {
        const itemList = Array.from({ length: this.quantity }, () => 1);
        // 未編集をカウントしていく
        for (const item of this.$store.state.currentCanvasData.itemList.slice()) {
          for (let i = 0; i < this.quantity; ++i) {
            if (item.textArray[i] == "") {
              itemList[i] = 0;
            }
          }
        }

        return itemList.filter((item) => item == 1).length;
      }

      return 0;
    },
    getTitleText() {
      switch (this.$store.state.selectProductId) {
        case ProductId.S:
        case ProductId.S_SVG:
        case ProductId.S_SHARE:
          return "Sサイズ";
        case ProductId.M:
        case ProductId.M_SVG:
        case ProductId.M_SHARE:
          return "Mサイズ";
        case ProductId.L:
        case ProductId.L_SVG:
        case ProductId.L_SHARE:
          return "Lサイズ";
        default:
          return "";
      }
    },
    getColorList() {
      return PreviewColorList;
    },
    getBackgroundBoxStyle() {
      return function (index) {
        return {
          border: this.$store.state.selectBackgroundColor == index ? "solid 2px" : "solid 1px",
          "border-color": this.$store.state.selectBackgroundColor == index ? "#000000" : "#999999",
          "background-color": PreviewColorList[index],
        };
      };
    },
    getCutlineBoxStyle() {
      return function (index) {
        return {
          border: this.$store.state.selectCutlineColor == index ? "solid 2px" : "solid 1px",
          "border-color": this.$store.state.selectCutlineColor == index ? "#000000" : "#999999",
          "background-color": PreviewColorList[index],
        };
      };
    },
    getCanvasSize() {
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      return {
        width: canvasSize.canvasScreenSizeWidth + "px",
        height: canvasSize.canvasScreenSizeHeight + "px",
      };
    },
    getControlAreaHeight() {
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      return {
        height: canvasSize.canvasScreenSizeHeight + "px",
      };
    },

    // ページネーション用
    // #region
    // 最大表示数
    getMaxPageView() {
      return 8;
    },

    // 総ページ数
    getMaxPageNum() {
      return this.quantity;
    },

    // 描画をするページのテキストを返す
    getLoopNumList() {
      let textList = [];
      const maxPage = Math.min(this.getMaxPageView, this.getMaxPageNum);

      if (this.getMaxPageView >= this.getMaxPageNum) {
        for (let i = 0; i < this.getMaxPageNum; ++i) {
          textList.push(i + 1);
        }
        return textList;
      }

      // 先頭は1固定
      textList.push(1);
      for (let i = 1; i < maxPage - 1; ++i) {
        // 「…」の可能性がある場所
        if (i == 1 && this.currentPageNum >= Math.ceil(maxPage / 2) + 1) {
          textList.push("…");
          continue;
        }

        // 「…」の可能性がある場所
        if (i == maxPage - 2 && this.getMaxPageNum - this.currentPageNum >= Math.floor(maxPage / 2) + 1) {
          textList.push("…");
          continue;
        }

        if (this.currentPageNum < Math.ceil(maxPage / 2) + 1) {
          // 序盤
          textList.push(i + 1);
        } else if (this.getMaxPageNum - this.currentPageNum >= Math.floor(maxPage / 2) + 1) {
          // 中盤
          textList.push(this.currentPageNum - Math.ceil(maxPage / 2) + 1 + i);
        } else {
          // 終盤
          textList.push(this.getMaxPageNum - maxPage + i + 1);
        }
      }

      // 最後は最大数固定
      textList.push(this.getMaxPageNum);

      return textList;
    },
    // #endregion
  },
  created: function () {
    this.$store.commit("showRightMenu");
    this.$store.commit("setCurrentSelectPlateNo", 0);
  },
  methods: {
    clickBackgroundBox(index) {
      this.$store.commit("setSelectBackgroundColor", index);
    },
    clickCutlineBox(index) {
      this.$store.commit("setSelectCutlineColor", index);
    },
    clickListPreview() {
      this.$store.commit("showImagsPreview");
    },

    isListEditMode() {
      return this.$store.state.isListEditMode;
    },

    // clickPreviousBtn() {
    //   this.$store.commit(
    //     "setCurrentSelectPlateNo",
    //     Math.max(0, this.$store.state.currentSelectPlateNo - 1)
    //   );
    // },

    // clickNextBtn() {
    //   this.$store.commit(
    //     "setCurrentSelectPlateNo",
    //     Math.min(this.quantity - 1, this.$store.state.currentSelectPlateNo + 1)
    //   );
    // },

    async clickCart() {
      console.log("clickCart");
      if (!this.$store.state.currentProduct) {
        return;
      }

      // 未編集項目がある場合は注意ダイアログ
      if (this.quantity != this.editedNum) {
        this.$store.commit("setYesNoDialogCallback", this.addCartProcess);
        this.$store.commit("showYesNoDialog", "未編集項目があります。\nよろしいですか？");
      } else {
        await this.addCartProcess();
      }
    },

    async addCartProcess() {
      this.$store.commit("showProgress", true);
      this.$store.commit("setProgressMessages", ["デザインデータ保存中…", "しばらくお待ちください"]);

      // registDesign が失敗したらカートの品の削除と再投入へ進まない（catch 内の return はアロー関数を抜けるだけで、外側は続く）
      let failed = false;
      await this.$store.state.draftManager
        .registDesign(this.$store.state.currentProduct, false, this.$store)
        .catch((e) => {
          this.$handleError("010", e, { hideProgress: true });
          failed = true;
          return;
        });
      if (failed) return;
      this.$store.commit("setProgress", 15);

      // プロダクトタイプが再編集になっている場合はカートの中のものを削除
      if (this.$store.state.currentProduct.cartId != "") {
        await this.$store.state.cartManager.delete(this.$store.state.currentProduct.cartId).catch((e) => {
          this.$handleError("011", e, { hideProgress: true });
          return;
        });
      }

      let self = this;
      await this.$store.state.cartManager
        .addCartProduct(this.$store.state.currentProduct, false, function (progress) {
          self.$store.commit("setProgress", 15 + (85 / 100) * progress);
        })
        .catch((e) => {
          this.$handleError("012", e, { hideLoading: true });
          return;
        });

      this.$store.commit("hideProgress");
      this.$store.commit("showMessage", "カートに追加しました");

      // 表示を戻す
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      this.$store.commit("setRightViewState", RightViewState.Cart);
    },

    jumpPage() {
      if (!isNaN(this.jumpPageNum)) {
        let num = Number(this.jumpPageNum);
        if (0 < num && num <= this.getMaxPageNum) {
          this.currentPageNum = num;
          this.$store.commit("setCurrentSelectPlateNo", this.currentPageNum - 1);
        }
      }
    },

    // ページネーション用
    // #region
    prevPage() {
      if (this.currentPageNum != 1) {
        this.currentPageNum -= 1;
        this.jumpPageNum = this.currentPageNum;
        this.$store.commit("setCurrentSelectPlateNo", this.currentPageNum - 1);
      }
    },

    nextPage() {
      if (this.currentPageNum != this.getMaxPageNum) {
        this.currentPageNum += 1;
        this.jumpPageNum = this.currentPageNum;
        this.$store.commit("setCurrentSelectPlateNo", this.currentPageNum - 1);
      }
    },

    clickPage(num) {
      if (!isNaN(num)) {
        this.currentPageNum = num;
        this.$store.commit("setCurrentSelectPlateNo", this.currentPageNum - 1);
      }
    },
    // #endregion
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview {
  max-width: 805px;
  width: 100%;
  padding: 16px 32px;
}
.control-area {
  margin-left: 16px;
  width: 243px;
}
.preview-btn {
  height: 40px;
  margin-top: 8px;
  font-weight: bold;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 4px;
  background-color: $background-white-color;
}
.preview-border {
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
}
.preview-title {
  color: $text-white-color;
  background-color: $primary-main-color;
}
.color_box {
  height: 25px;
  width: 25px;
  margin: 2px;
  border-radius: 5px;
}

.jump-border {
  border: 1px solid $border-sub-color;
}

// ページネーション用
// #region
.pagination-text {
  color: $text-main-color;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.pagination-text-select {
  color: $primary-main-color;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.pagination-btn {
  border: 2px solid $primary-main-color;
}

.radio-btn {
  height: 25px;
  width: 25px;
  accent-color: #8593bc;
}

// #endregion
</style>
